module.exports = __webpack_public_path__ + "img/logo_ru.704a026.png";